module.exports = __webpack_public_path__ + "c3a024757fdfcf9d4b433394c786f697.png";